import React from "react";
import Navbar from "../../../Navbar/Navbar";
import PeopleSecond from "./PeopleSecond";

const InputPeople = () => {
  return (
    <>
      <Navbar />
      <div className="mt5"></div>

      <PeopleSecond />
    </>
  );
};

export default InputPeople;
